import axios from 'axios';

const handleWorldpos = async (body) => axios({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${process.env.REACT_APP_COINCAEX_AJAX}handleWorldPos`,
    data: body,
});

export { handleWorldpos }
